import Vue from 'vue'
import Vuex from 'vuex'
import VueLocalStorage from 'vue-ls'

Vue.use(VueLocalStorage)
Vue.use(Vuex)

const state = {
  isLogged: (Vue.ls.get('token', 'unauth') !== 'unauth')
}

const mutations = {
  LOGIN_USER (state) {
    state.isLogged = true
  },
  LOGOUT_USER (state) {
    state.isLogged = false
  }
}

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js